module.exports = __webpack_public_path__ + "img/red-triangle-right.b1b155c.png";